import StatOutMoneyPlan from "./indexStatOutMoneyPlan";
import StatOutMoneyPlanLead from "./indexStatOutMoneyPlanLead";
import { TabPane, Tabs } from "@douyinfe/semi-ui";
import { IconIdCard, IconMoneyExchangeStroked } from "@douyinfe/semi-icons";

export default function StatOutMoneyPlanLeadAndCustomer() {
  return (
    <Tabs type="line" style={{ margin: 10 }}>
      <TabPane
        tab={
          <span>
            <IconMoneyExchangeStroked />
            出款人
          </span>
        }
        itemKey="1"
      >
        <StatOutMoneyPlan
        />
      </TabPane>

      <TabPane
        tab={
          <span>
            <IconIdCard />
            客户
          </span>
        }
        itemKey="2"
      >
        <StatOutMoneyPlanLead 
        />
        ;
      </TabPane>
    </Tabs>
  );
}
